import React, { useState } from "react";
import ItemsCarousel from "react-items-carousel";
import poster1 from "../asset/img_p1.png";
import poster2 from "../asset/img_p2.jpg";
import poster3 from "../asset/img_p3.png";
import poster4 from "../asset/img_p4.png";
import poster5 from "../asset/img_p5.jpg";
// import poster6 from "../asset/img_p6.jpg";
import { makeStyles } from "@mui/styles";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import { Typography } from "./Typography";
import { MobileWeb } from "../components/mobile/BreakPoint";

const useStyles = makeStyles((theme) => ({
  carousel: {
    display: "block",
    width: 1290,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      display: "none",
    },
  },
  mCarousel: {
    display: "none",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      display: "block",
      textAlign: "center",
      position: "relative",
      top: 30,
    },
  },
  cBtn: {
    display: "block",
    height: "30px",
    width: "30px",
    borderRadius: "50%",
    border: "1px solid #000",
  },
  posterImg: {
    width: 250,
    height: 355,
    background: "#fff",
  },
  mPosterImg: {
    width: 220,
    height: 310,
    background: "#fff",
  },
  posterCon: {
    textAlign: "center",
  },
}));

export const ItemCarousel = () => {
  const classes = useStyles();
  const [activeItemIndex, setActiveItemIndex] = useState(0);
  const chevronWidth = 130;
  return (
    <div>
      <div
        className={classes.carousel}
        style={{ padding: `0 ${chevronWidth}px` }}
      >
        <ItemsCarousel
          infiniteLoop
          requestToChangeActive={setActiveItemIndex}
          activeItemIndex={activeItemIndex}
          numberOfCards={3}
          slidesToScroll={3}
          gutter={20}
          leftChevron={
            <button
              cursor="pointer"
              style={{
                border: "none",
                backgroundColor: "transparent",
                cursor: "pointer",
              }}
            >
              <ArrowBackIosIcon
                style={{
                  fontSize: "80px",
                  position: "relative",
                  width: "80px",
                  color: "#c4c4c4",
                  top: "-40px",
                }}
              />
            </button>
          }
          rightChevron={
            <button
              style={{
                border: "none",
                backgroundColor: "transparent",
                cursor: "pointer",
              }}
            >
              <ArrowForwardIosIcon
                style={{
                  fontSize: "80px",
                  position: "relative",
                  width: "80px",
                  color: "#c4c4c4",
                  top: "-40px",
                }}
              />
            </button>
          }
          outsideChevron
          chevronWidth={chevronWidth}
        >
          {/* 1번 포스터 */}
          <div className={classes.posterCon}>
            <img src={poster1} className={classes.posterImg} alt="poster1" />
            <Typography
              variant="body1"
              style={{ display: "block", textAlign: "center" }}
            >
              21년 간호행정학회 우수 포스터상
            </Typography>
          </div>
          {/* 2번 포스터 */}
          <div className={classes.posterCon}>
            <img src={poster2} className={classes.posterImg} alt="poster3" />
            <Typography
              variant="body1"
              style={{ display: "block", textAlign: "center" }}
            >
              21년 한국 간호행정학회 우수 포스터상
            </Typography>
            {/* sub타이틀 양식 */}
            {/* <Typography
              variant="Caption1"
              style={{
                display: "block",
                textAlign: "center",
                color: "#707070",
              }}
            >
              텍스트
            </Typography> */}
          </div>
          {/* 3번 포스터 */}
          <div className={classes.posterCon}>
            <img src={poster3} className={classes.posterImg} alt="poster2" />
            <Typography
              variant="body1"
              style={{ display: "block", textAlign: "center" }}
            >
              21년 한국 정신간호학회 포스터 발표
            </Typography>
          </div>
          {/* 4번 포스터 */}
          <div className={classes.posterCon}>
            <img src={poster4} className={classes.posterImg} alt="poster4" />
            <Typography
              variant="body1"
              style={{ display: "block", textAlign: "center" }}
            >
              SimBridge(사례기반 VR 프로그램)를 적용한 연구
            </Typography>
          </div>
          {/* 5번 포스터 */}
          <div className={classes.posterCon}>
            <img src={poster5} className={classes.posterImg} alt="poster4" />
            <Typography
              variant="body1"
              style={{ display: "block", textAlign: "center" }}
            >
              The 13th International Nursing Conference 포스터 발표
            </Typography>
            <Typography
              variant="Caption1"
              style={{
                display: "block",
                textAlign: "center",
                color: "#707070",
              }}
            >
              (Global Virtual Simulation Program of
              <br /> Patient Safety for Nursing Students)
            </Typography>
          </div>
          {/* 빈 포스터 */}
          <div className={classes.posterCon}></div>
        </ItemsCarousel>
      </div>
      {/* 모바일 화면 Carousel */}
      <div className={classes.mCarousel}>
        <div>
          <ItemsCarousel
            infiniteLoop
            requestToChangeActive={setActiveItemIndex}
            activeItemIndex={activeItemIndex}
            numberOfCards={1}
            slidesToScroll={1}
            gutter={20}
            rightChevron={
              <ArrowForwardIosIcon
                type="right"
                style={{ top: "-40px", position: "relative" }}
              />
            }
            leftChevron={
              <ArrowBackIosIcon
                type="left"
                style={{ top: "-40px", position: "relative" }}
              />
            }
            chevronWidth={60}
          >
            {/* 모바일 1번 포스터 */}
            <div>
              <img src={poster1} className={classes.mPosterImg} alt="poster1" />
              <Typography
                variant="body1"
                style={{ display: "block", textAlign: "center" }}
              >
                21년 간호행정학회 우수 포스터상
              </Typography>
            </div>
            {/* 모바일 2번 포스터 */}
            <div>
              <img src={poster2} className={classes.mPosterImg} alt="poster2" />
              <Typography
                variant="body1"
                style={{ display: "block", textAlign: "center" }}
              >
                21년 한국 간호행정학회 우수 포스터상
              </Typography>
            </div>
            {/* 모바일 3번 포스터 */}
            <div>
              <img src={poster3} className={classes.mPosterImg} alt="poster3" />
              <Typography
                variant="body1"
                style={{ display: "block", textAlign: "center" }}
              >
                21년 한국 정신간호학회 포스터 발표
              </Typography>
            </div>
            {/* 모바일 4번 포스터 */}
            <div>
              <img src={poster4} className={classes.mPosterImg} alt="poster4" />
              <Typography
                variant="body1"
                style={{ display: "block", textAlign: "center" }}
              >
                SimBridge(사례기반 VR 프로그램)를 적용한 연구
              </Typography>
            </div>
            {/* 모바일 5번 포스터 */}
            <div>
              <img src={poster5} className={classes.mPosterImg} alt="poster4" />
              <Typography
                variant="body1"
                style={{ display: "block", textAlign: "center" }}
              >
                The 13th International Nursing Conference 포스터 발표
              </Typography>
              <Typography
                variant="Caption1"
                style={{
                  display: "block",
                  textAlign: "center",
                  color: "#707070",
                }}
              >
                (Global Virtual Simulation Program of
                <br /> Patient Safety for Nursing Students)
              </Typography>
            </div>
          </ItemsCarousel>
        </div>
      </div>
    </div>
  );
};
